import moment from 'moment';
import { REQUEST_TYPES } from './constants';

export const getShipmentDetails = (shipmentData = {}) => {
  const {
    isLoadedDelivered = false,
    isLoadedPickUp = false,
    isEmptyDelivered = false,
    isEmptyPickUp = false,
  } = shipmentData;

  const isMultiple = (isEmptyDelivered || isLoadedDelivered) && (isEmptyPickUp || isLoadedPickUp);
  const pickupStatus = isLoadedPickUp ? 'Loaded' : 'Empty';
  const deliveryStatus = isLoadedDelivered ? 'Loaded' : 'Empty';
  const pickupLabel = `Pickup ${pickupStatus}`;
  const deliveryLabel = `Delivery ${deliveryStatus}`;

  const nonMultiLabel = isLoadedPickUp
    ? 'Pickup Loaded'
    : isEmptyPickUp
      ? 'Pickup Empty'
      : isLoadedDelivered
        ? 'Delivery Loaded'
        : 'Delivery Empty';

  const nonMultiStatus = nonMultiLabel.includes('Loaded') ? 'Loaded' : 'Empty';

  return {
    isMultiple,
    pickupStatus,
    deliveryStatus,
    pickupLabel,
    deliveryLabel,
    nonMultiLabel,
    nonMultiStatus,
  };
};

export const createShipmentData = ({
  createdBy,
  shipmentNumber,
  companyId,
  branchKey,
  poNumberValue,
  soNumberValue,
  requestID,
  trailerId,
  shipmentOriginInformation,
  shipmentDestinationInformation,
  shipmentProductInformation,
  formValues,
}) => {
  const expShipDate = formValues.orgLocations[0].orgETD;
  const expDeliveryDate = formValues.destLocations[0].destETA;
  return {
    userId: createdBy,
    isCollectBol: 0,
    adhocCarrierName: '',
    shipmentInformationRequest: {
      shipmentKey: 0,
      shipmentNo: shipmentNumber,
      status: 'New',
      customerKey: companyId,
      branchKey: branchKey,
      accountNumber: '',
      expShipDate: expShipDate || null,
      expDeliveryDate: expDeliveryDate || null,
      fobCode: '',
      freightAllowance: '',
      shipmentType: REQUEST_TYPES.INBOUND.value,
      shipmentTerms: 'P',
      requiredCarrierKey: 0,
      carrierRequirements: '',
      specialServices: '',
      serviceKey: 0,
      incoCode: '',
      incoPoint: '',
      paidAmount: 0,
      rateShopCost: 0,
      paymentTerms: '',
      customerContact: '',
      createdBy: 0,
      transportationMode: '',
      carrierKey: '',
      shipmentNotes: '',
      adhocCarrierName: '',
      detailNotes: '',
      trackingDateTime: null,
      masterShipmentCurrentWeight: 0,
      currencyCode: '',
      rateShopKey: 0,
      cargoType: '',
      approvalNumber: '',
      masterShipmentCurrentQty: 0,
      bolNumber: '',
      proNo: '',
      masterBolNumber: '',
      trailerNumber: formValues.selTrailer,
      quoteNo: '',
      projectNo: '',
      purchaseOrderNumber: poNumberValue,
      salesOrderNumber: soNumberValue,
      trailerId: trailerId,
      rateType: '',
      masterShipment: 0,
      trailerRequestID: requestID,
      yardID: formValues.selYardValue || 0,
    },
    shipmentOriginInformation: shipmentOriginInformation,
    shipmentDestinationInformation: shipmentDestinationInformation,
    shipmentBillToRequestInformation: {
      shipmentKey: 0,
      name: '',
      vatNumber: '',
      address1: '',
      address2: '',
      city: '',
      stateCode: '',
      postalCode: '',
      countryCode: '',
      contact: '',
      contactEmail: '',
      createdBy: createdBy,
      countryName: '',
      stateName: '',
    },
    shipmentVendorRequestInformation: [],
    shipmentProductInformation: shipmentProductInformation,
    shipmentDocumentInformation: [],
    shipmentCategoryInformation: [],
    purchaseSalesOrderInformation: [],
    shipmentAccessorialInformation: [],
    shipmentTaxInformation: [],
    shipmentRateShopInformation: [],
  };
};

export const OriginDataBuilder = (data, userID) => {
  return data.map((element) => {
    const currentDate = moment();
    return {
      shipmentKey: 0,
      originKey: 0,
      sequence: 1,
      legNumber: 0,
      stopType: '1',
      shipRecKey: 0,
      customerKey: 0,
      name: element.orgname,
      addr1: !element.orgaddress1 ? 'NS' : element.orgaddress1,
      addr2: '',
      city: !element.orgcity ? 'NS' : element.orgcity,
      state: !element.orgstate ? 'NS' : element.orgstate,
      zip: !element.orgzip ? 'NS' : element.orgzip,
      countryCode: !element.orgcountry ? 'NS' : element.orgcountry,
      searchId: !element.orgcustref ? '' : element.orgcustref,
      createdBy: userID,
      oldStopSequence: 0,
      portType: '',
      portRecKey: 0,
      gridOperation: 1,
      displaySequence: 1,
      shipmentOriginAdditionalInformation: {
        shipmentKey: 0,
        sequence: 1,
        shipperRequestedShipDate: currentDate,
        carrierAppontmentShipDate: null,
        carrierActualShipDate: null,
        shipperRequestedDeliveryDate: null,
        carrierAppontmentDeliveryDate: null,
        carrierActualDeliveryDate: null,
        doorDockID: '',
        pickupDeliveryID: '',
        contactName: '',
        contactEmail: '',
        phone: '',
        createdBy: userID,
        hoursOfOperation: '',
        appointmentType: '',
        gridOperation: 1,
        oldStopSequence: 0,
        displaySequence: 1,
        isResetNew: 0,
        uom: '',
        legMiles: 0,
        extension: '',
        dockNumber: '',
        taxId: '',
      },
      countryName: '',
      stateName: '',
      portName: '',
      isResetNew: 0,
      trailerNumber: '',
    };
  });
};

export const DestinationDataBuilder = (data, userID) => {
  const currentDate = moment();
  return data.map((element) => ({
    shipmentKey: 0,
    destinationKey: 0,
    sequence: element.seqVal || 99,
    legNumber: 0,
    stopType: '2',
    shipRecKey: 0,
    customerKey: 0,
    name: element.destname,
    addr1: !element.destaddress1 ? 'NS' : element.destaddress1,
    addr2: '',
    city: !element.destcity ? 'NS' : element.destcity,
    state: !element.deststate ? 'NS' : element.deststate,
    zip: !element.destzip ? 'NS' : element.destzip,
    countryCode: !element.destcountry ? 'NS' : element.destcountry,
    searchId: !element.destcustref ? '' : element.destcustref,
    createdBy: userID,
    oldStopSequence: 0,
    portType: '',
    portRecKey: 0,
    gridOperation: 1,
    displaySequence: element.seqVal || 99,
    shipmentDestinationAdditionalInformation: {
      shipmentKey: 0,
      sequence: element.seqVal || 99,
      shipperRequestedShipDate: null,
      carrierAppontmentShipDate: null,
      carrierActualShipDate: null,
      shipperRequestedDeliveryDate: currentDate,
      carrierAppontmentDeliveryDate: null,
      carrierActualDeliveryDate: null,
      doorDockID: '',
      pickupDeliveryID: '',
      contactName: '',
      contactEmail: '',
      phone: '',
      createdBy: userID,
      hoursOfOperation: '',
      appointmentType: '',
      gridOperation: 1,
      oldStopSequence: 0,
      displaySequence: element.seqVal || 99,
      isResetNew: 0,
      uom: '',
      legMiles: 0,
      extension: '',
      dockNumber: '',
      taxId: '',
    },
    countryName: '',
    stateName: '',
    portName: '',
    isResetNew: 0,
    trailerNumber: '',
  }));
};

export const BuildProdDetailsInfo = (data, userID) =>
  data.orgLocations.map((element) => {
    return {
      shipmentKey: 0,
      itemSequenceKey: 0,
      quantity: 0,
      unitMeasure: 'LB',
      productCode: data.productType?.toString() || '2',
      productDescription: data.Commodity || 'Books',
      class: '',
      deliveryID: '',
      length: 0,
      height: 0,
      width: 0,
      dimUom: 'N',
      weight: 0,
      actualWeight: 0,
      weightUom: 'LB',
      cube: 0,
      billQty: 1,
      billQtyUom: 'LB',
      createdBy: userID,
      stcDescription: '',
      hazmatUnNo: '',
      hazmat: '',
      poNumber: '',
      soNumber: '',
      reference1: '',
      palletLoadType: 'Non Stackable',
      gridOperation: 1,
      shipmentDetailsID: 0,
      className: '',
      unitMeasureName: '',
      weightUomName: '',
      dimUomName: '',
      billQtyUomName: '',
      crateNo: '',
      cartonQty: 0,
      cartonUOM: '',
      unitPrice: 0,
      nmfcNumber: '',
      hts: '',
      eccn: '',
      countryOfOrigin: '',
      palletPackageType: '',
      bookOks: element.orgBookOks === '' ? 0 : element.orgBookOks,
      book: element.orgBookWeight === '' ? 0 : element.orgBookWeight,
      soft: element.orgSoftWeight === '' ? 0 : element.orgSoftWeight,
      softOks: element.orgSoftOks === '' ? 0 : element.orgSoftOks,
      misc: element.orgMiscWeight === '' ? 0 : element.orgMiscWeight,
      miscOKs: element.orgMiscOks === '' ? 0 : element.orgMiscOks,
    };
  });

export const BuildOrgInfo = (data, trailerId) => {
  const currentDate = moment();
  return data.map((element) => ({
    trailerMovementID: 0,
    spotDate: element.orgSpotDate,
    etd: currentDate,
    trailerID: trailerId,
    clothOKs: element.orgSoftOks === '' ? 0 : element.orgSoftOks,
    miscOKs: element.orgMiscOks === '' ? 0 : element.orgMiscOks,
    softWeight: element.orgSoftWeight === '' ? 0 : element.orgSoftWeight,
    hardWeight: element.orgMiscWeight === '' ? 0 : element.orgMiscWeight,
    furniturePieces: element.orgFurn === '' ? 0 : element.orgFurn,
    otherLargeItems: element.orgOLI === '' ? 0 : element.orgOLI,
    sendComplete: false,
    actualEntryDate: currentDate,
    bookOks: element.orgBookOks === '' ? 0 : element.orgBookOks,
    bookWeight: element.orgBookWeight === '' ? 0 : element.orgBookWeight,
  }));
};

export const BuildDestInfo = (data, trailerId) => {
  const currentDate = moment();
  return data.map((element) => ({
    trailerMovementID: 0,
    eta: element.descETA || currentDate,
    trailerID: trailerId,
    clothOKs: element.destSoftOks === '' ? 0 : element.destSoftOks,
    miscOKs: element.destMiscOks === '' ? 0 : element.destMiscOks,
    softWeight: element.destSoftWeight === '' ? 0 : element.destSoftWeight,
    hardWeight: element.destMiscWeight === '' ? 0 : element.destMiscWeight,
    furniturePieces: element.destFurn === '' ? 0 : element.destFurn,
    otherLargeItems: element.destOLI === '' ? 0 : element.destOLI,
    receiveComplete: false,
    actualEntryDate: currentDate,
    bookOks: element.destBookOks === '' ? 0 : element.destBookOks,
    bookWeight: element.destBookWeight === '' ? 0 : element.destBookWeight,
    deliverySequence: 0,
  }));
};

export const CreateMovementData = ({
  branchKey,
  requestID,
  formValues,
  checkOptions,
  trailerRequest,
  trailerShipping,
}) => {
  return {
    trailerMovement: {
      trailerMovementID: 0,
      branchKey: formValues?.orgLocations[0]?.orgLocationId,
      movementDate: null,
      vendorID: '',
      okTransferred: 0,
      miscTransferred: 0,
      booksOksTrans: 0,
      transferType: 0,
      positionDate: null,
      trailerNumber: formValues.selTrailer,
      clothWeightTransferred: 0,
      miscWeightTransferred: 0,
      bookWeightTrans: 0,
      furniturePiecesTrans: 0,
      otherLargeitemsTrans: 0,
      merchendiseCost: 0,
      dataOrigin: '',
      recordType: 0,
      adjusted: true,
      adjustmentRefID: 0,
      adjustmentRefDate: null,
      adjustmentReasonCodeID: 0,
      adjustmentComment: formValues?.txtinvJusti,
      trailerTransfer: false,
      unloadComplete: true,
      unloadCompleteDate: null,
      trailerShippingID: formValues?.orgLocations[0]?.orgLocationId,
      trailerReceivingID: branchKey,
      refferedToPRM: true,
      deliveryLocationID: formValues?.destLocations[0]?.destLocationId,
      transferReportnumber: '',
      softCost: 0,
      miscCost: 0,
      bookCost: 0,
      furnitureCost: 0,
      oliCost: 0,
      trailerRequestID: requestID,
      productType: formValues?.productType?.toString() || '2',
      unitEmpty: checkOptions.unitEmpty,
      liveUnload: checkOptions.liveUnload,
      directFromPartner: checkOptions.directFromPartner,
      liveLoad: checkOptions.liveLoad,
      rollDoor: checkOptions.rollDoor,
      rentalTrailer: checkOptions.rentalTrailer,
      partnerId: formValues.selPartner,
    },
    trailerShipping: trailerShipping,
    trailerRequest: trailerRequest,
  };
};
